module.exports = __webpack_public_path__ + "83967b5b9ee0a35d2893fd845a757cf2.svg";